class SentenciaJuicio{
  constructor({resultadoSentencia, fechaSentencia, capital, interes, hsyCs, fechaApelacion, parteApela,instanciaSentencia})
  {
    this.resultadoSentencia=resultadoSentencia
    this.fechaSentencia=fechaSentencia
    this.capital=capital
    this.interes=interes
    this.hsyCs=hsyCs
    this.fechaApelacion=fechaApelacion
    this.parteApela=parteApela 
    this.instanciaSentencia=instanciaSentencia 
  }
}

export default SentenciaJuicio
